module.exports = __webpack_public_path__ + "img/violet_087.036d8091.png";